<template>
    <div class="c-app">
        <TheSideBar />
        <CWrapper>
            <TheHeader />
            <div class="c-body">
                <main class="c-main">
                    <CContainer fluid>
                        <transition name="fade" mode="out-in">
                            <router-view></router-view>
                        </transition>
                    </CContainer>
                </main>
            </div>
            <TheFooter />
        </CWrapper>
    </div>
</template>

<script>
import TheSideBar from './SideBar'
// import TheSideBar from '@/components/Layout/SideBar'
import TheHeader from '@/components/Layout/NavBar'
import TheFooter from '@/components/Layout/Footer'

export default {
    name: "TheContainer",
    components: {
        TheSideBar,
        TheHeader,
        TheFooter,
    },
    mounted() {},
    computed: {}
}
</script>

<style scoped>

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

</style>
